"use client"

import { Typography } from "antd";
import { LinkProps } from "antd/es/typography/Link";
import { usePathname } from "next/navigation";
import { FC } from "react";

const Link: FC<LinkProps> = (props) => {
  const pathname = usePathname()

  let _href = (props.href as string) || ""
  const lang = pathname.startsWith("/en") ? "en" : pathname.startsWith("/vi") ? "vi" : ""
  if (!_href.startsWith('http://') && !_href.startsWith('https://') && !_href.startsWith("/vi") && !_href.startsWith("/en")) {
    _href = `/${lang || 'vi'}${_href}`
  }

  return (
    <Typography.Link {...props} href={props.href ? _href : undefined} />
  )
}

Link.displayName = 'Link'

export default Link